import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export const enum Action {
	EMAIL = 'email',
	CONNECT = 'connect',
}

export default class UserPopupForbiddenActionComponent extends PopupInnerModalComponent<PopupData.User.ForbiddenAction> {
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('infolayer') declare infolayerService: Service.Infolayer;

	get isEmailVerification() {
		return this.popupData.type === Action.EMAIL;
	}

	get isSourceConnect() {
		return this.popupData.type === Action.CONNECT;
	}

	get icon(): IconName {
		return this.isEmailVerification ? 'Mail' : 'DataManager';
	}

	@action
	resendVerificationEmail() {
		void this.currentUserService.resendVerifyEmail().then(() => {
			this.infolayerService.ok('Verification email sent!');
		});
		this.close();
	}
	<template>
		<div class="content">
			<CommonUiIconComponent @name={{this.icon}} @size="2xl" />
			<h3>
				{{#if this.isEmailVerification}}
					A verification email is waiting in your inbox to be confirmed first
				{{else if this.isSourceConnect}}
					Only admins can add new data sources
				{{/if}}
			</h3>
			<p>
				{{#if this.isEmailVerification}}
					To
					{{this.popupData.text}}, we need to verify your email first.
					<br />
					If you haven't got the verification email, we can
					<a role="button" {{on "click" this.resendVerificationEmail}}>send it again</a>.
				{{else if this.isSourceConnect}}
					Please contact an admin in your account to add a new data source.
				{{/if}}
			</p>
			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent @text="Close" @onTrigger={{this.close}} />
				</div>
			</div>
		</div>
	</template>
}
